import PropTypes from 'prop-types'
import { Icon, P1, Menu, MenuItem, Radio, Tooltip } from '@moneymade/moneymade-ui'

import styles from './Button.module.scss'

const Button = ({
  isLogged,
  isAuthChecked,
  blocks,
  isMenu,
  checkboxes,
  name,
  setMenu,
  handleChange,
  handleSetUserFields
}) => (
  <div className={styles.Button}>
    <button type="button" className={styles.FilterBtn} onClick={event => setMenu(event.currentTarget)}>
      <P1>{name || `Compare`}</P1>
      <Icon icon="icon-dropdown-down" className={styles.DropDown} size={11} />
    </button>

    <Menu isOpen={isMenu} position="bottom" handleClose={() => setMenu(false)} className={styles.Menu}>
      {blocks?.map(({ name: blockName, slug, unauthLock }, key) => (
        <MenuItem
          key={key}
          onClick={() =>
            unauthLock &&
            !(isLogged && isAuthChecked) &&
            handleSetUserFields([
              { key: 'isAuthModal', value: true },
              { key: 'authModalType', value: 'signUp' }
            ])
          }
        >
          {unauthLock && !(isLogged && isAuthChecked) ? (
            <Tooltip tooltipText={`${unauthLock ? 'Members Only' : ''}`} position="top" color="dark">
              <span className={styles.LockField}>
                <Radio
                  label={blockName}
                  labelPosition="right"
                  checked={checkboxes[slug].checked}
                  onChange={() => handleChange(slug)}
                  disabled={!(!unauthLock ? true : isLogged && isAuthChecked)}
                />

                {unauthLock && <Icon icon="icon-lock" className={styles.Lock} size={15} />}
              </span>
            </Tooltip>
          ) : (
            <span className={styles.LockField}>
              <Radio
                label={blockName}
                labelPosition="right"
                checked={checkboxes[slug].checked}
                onChange={() => handleChange(slug)}
                disabled={!(!unauthLock ? true : isLogged && isAuthChecked)}
              />
            </span>
          )}
        </MenuItem>
      ))}
    </Menu>
  </div>
)

Button.propTypes = {
  isAuthChecked: PropTypes.bool,
  isLogged: PropTypes.bool,
  isMenu: PropTypes.bool,
  blocks: PropTypes.arrayOf(PropTypes.object),
  checkboxes: PropTypes.shape({}),
  name: PropTypes.string,
  setMenu: PropTypes.func,
  handleChange: PropTypes.func,
  handleSetUserFields: PropTypes.func
}

Button.defaultProps = {
  isAuthChecked: true,
  isLogged: false,
  blocks: [],
  isMenu: false,
  checkboxes: {},
  name: '',
  setMenu: () => {},
  handleChange: () => {},
  handleSetUserFields: () => {}
}

export default Button
